import { AttributeValue, DynamoDBClient, GetItemCommand, PutItemCommand } from '@aws-sdk/client-dynamodb'
import { marshall, unmarshall } from '@aws-sdk/util-dynamodb'
import crypto from 'crypto'
import { type CreateSalesforceEvent, salesforcePayloadSchema } from './schema'

export class SalesforceEventRepository {
  private client: DynamoDBClient
  private tableName = 'salesforce_events'

  constructor() {
    this.client = new DynamoDBClient({})
  }

  async create(event: CreateSalesforceEvent) {
    const id = crypto.randomUUID()
    const parsed = salesforcePayloadSchema.parse(event)

    const command = new PutItemCommand({
      TableName: this.tableName,
      Item: marshall({
        id,
        event: parsed,
        record_id: parsed.record_id,
        received_at: new Date().toISOString(),
      }),
    })

    await this.client.send(command)

    return { id }
  }

  async getById(id: string) {
    const command = new GetItemCommand({
      TableName: this.tableName,
      Key: marshall({ id }),
    })

    const result = await this.client.send(command)

    if (!result.Item) {
      return null
    }

    const item = unmarshall(result.Item as Record<string, AttributeValue>)

    return salesforcePayloadSchema.parse(item.event)
  }
}
